import useLocales from "src/hooks/useLocales";

const Translate = ({ children }) => {
  const { translate } = useLocales();

  return translate(children);
};

export default Translate;
